// @ts-nocheck
/**
 * Thin axios wrappers over the structured-letter endpoint contract
 * (Plans 06-05 / 06-06). No business logic here — callers own state.
 *
 * All paths are relative to the API root; the shared axios instance
 * attaches the JWT and base URL.
 */
import api from '../utils/axios';

export async function getLetterSections(letterType, letterId) {
  const res = await api.get(`/documents/letters/${letterType}/${letterId}/sections/`);
  return res.data;
}

export async function patchLetterSection(sectionId, { content_json, content_html }) {
  const res = await api.patch(`/documents/letter-sections/${sectionId}/`, {
    content_json,
    content_html,
  });
  return res.data;
}

export async function approveLetter(letterType, letterId) {
  const res = await api.post(`/documents/letters/${letterType}/${letterId}/approve/`);
  return res.data;
}

export async function startNewVersion(letterType, letterId) {
  const res = await api.post(`/documents/letters/${letterType}/${letterId}/new-version/`);
  return res.data;
}

export async function getPreviewPdfBlob(letterType, letterId) {
  const res = await api.get(`/documents/letters/${letterType}/${letterId}/preview-pdf/`, {
    responseType: 'blob',
  });
  return res.data;
}

/**
 * Fetches the approved final PDF and triggers a browser download via the
 * established blob pattern (see ExportStep.js). Filenames are PHI-free
 * by convention: appeal-letter-v{N}.pdf / lmn-v{N}.pdf.
 */
export async function downloadFinalPdf(letterType, letterId, filename) {
  const res = await api.get(`/documents/letters/${letterType}/${letterId}/final-pdf/`, {
    responseType: 'blob',
  });
  const blobUrl = window.URL.createObjectURL(
    new Blob([res.data], { type: 'application/pdf' })
  );
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
}
